import * as React from "react";
import cn from "classnames";

const styles = require("./style.less");

interface DataTableToolsRowProps {
    className?: string;
}

export class DataTableToolsRow extends React.Component<DataTableToolsRowProps> {
    render() {
        return <tr className={cn(this.props.className, styles.dataTableToolsRow)}>{this.props.children}</tr>;
    }
}
